import Axios from 'axios';

import api from 'utils/axios';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';
import { decamelizeKeys } from 'utils/humps';
import { trackEvent, EMixpanelEvents } from 'utils/mixpanel';

import { accountIdSelector } from '../../user/selectors';

import { setPagesAction, setSearchFiltersAction, setSearchResultCountersAction } from './index';

const decoratedAxiosGet = axiosGetAutoCancelDecorator();
export const getPagesTableThunk = (queryParams) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());

  try {
    const response = await decoratedAxiosGet(`/acc/${accountId}/pages`, { params: decamelizeKeys(queryParams) });

    dispatch(setPagesAction(response.data));
  } catch (err) {
    if (!(err instanceof Axios.Cancel)) {
      throw err;
    }
  }
};

export const duplicateOnePageFromPagesTableThunk = (id, params) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());

  const { data = {} } = await api.post(`/acc/${accountId}/pages/${id}`, params);
  dispatch(getPagesTableThunk());
  return data;
};

export const deleteOnePageFromPagesTableThunk = (pageId) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());
  trackEvent(EMixpanelEvents.DELETE_PAGE, { id: pageId });
  await api.delete(`/acc/${accountId}/pages/${pageId}`);
};

export const toggleActiveThunk = (pageId) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());
  await api.patch(`/acc/${accountId}/pages/${pageId}/toggle_active`);
};

const decoratedAxiosGetCounters = axiosGetAutoCancelDecorator();
export const getContentLibrarySearchCountersThunk = (q) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());

  try {
    const response = await decoratedAxiosGetCounters(`/acc/${accountId}/pages/search_counters`, {
      params: { q },
    });

    dispatch(setSearchResultCountersAction(decamelizeKeys(response.data)));
  } catch (err) {
    if (!(err instanceof Axios.Cancel)) {
      throw err;
    }
  }
};

const decoratedAxiosGetSearchFilters = axiosGetAutoCancelDecorator();
export const getSearchFiltersThunk =
  (page = 'content_library') =>
  async (dispatch, getStore) => {
    const accountId = accountIdSelector(getStore());

    try {
      const response = await decoratedAxiosGetSearchFilters(`/acc/${accountId}/search_filters?dashboard=${page}`);
      const decamelizedData = decamelizeKeys(response?.data?.data);
      const keyMapData = decamelizedData.reduce((res, cur) => {
        res[cur.table] = cur;

        return res;
      }, {});

      dispatch(setSearchFiltersAction(keyMapData));
    } catch (err) {
      if (!(err instanceof Axios.Cancel)) {
        throw err;
      }
    }
  };
